// extracted by mini-css-extract-plugin
export default {"Logo":"Qkeyimqd","LogoContainer":"ArzGkUtX"};